import { reducer as form } from 'redux-form/immutable';
import { combineReducers } from 'redux-immutable';
import resetAllData        from '../actions/resetAllData';
import accessibility       from '../modules/accessibility/store/reducers/accessibility';
import auth                from './../modules/auth/reducers';
import editableContent     from './../modules/editableContent/reducers';
import personalContent     from './../modules/personalContent/store/reducers';
import apiData             from './apiDataReducers';
import apiResources        from './apiResources';
import cookieSettings      from './cookieSettings';
import localShortlist      from './localShortlist';
import registration        from './registration';
import routerHistory       from './routerHistory';


export const STATE_KEY_API_DATA         = 'apiData';
export const STATE_KEY_PERSONAL_CONTENT = 'personalContent';

const appReducers = combineReducers({
  accessibility,
  auth,
  [STATE_KEY_API_DATA]:         apiData,          // <== New API data
  apiResources,                                   // <== Old API data - deprecated @todo Remove once all migrated to
                                                  // using `apiData`
  cookieSettings,
  editableContent,
  form,
  localShortlist,
  [STATE_KEY_PERSONAL_CONTENT]: personalContent,
  registration,
  routerHistory,
});

const rootReducer = (initialState, action) => {

  // Clear the initialState when the user logs out.

  if (action.type === String(resetAllData)) {

    // Reset store to default, empty state.
    return appReducers(undefined, {type: '@@INIT'});

  }

  return appReducers(initialState, action);

};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js